import { RowModel } from './types';

export interface HookRow {
  cellData: unknown[];
  row: string;
  data: { id: string; status?: string };
}

const str = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '-';
  return String(value);
};

export const normalizeRow = (hookRow: HookRow): RowModel => {
  const [
    disclosureId,
    formTitle,
    category,
    employee,
    submitted,
    ,
    flags,
    reviewer,
    reviewerGroup,
  ] = hookRow.cellData;

  return {
    id: hookRow.data.id,
    status: hookRow.data.status ?? '',
    disclosureId: str(disclosureId),
    formTitle: str(formTitle),
    category: str(category),
    employee: str(employee),
    country: '-',
    submittedDate: str(submitted),
    reviewer: str(reviewer),
    reviewerGroup: Array.isArray(reviewerGroup)
      ? reviewerGroup
          .filter((item): item is string => typeof item === 'string')
          .map((item) => item.trim())
          .filter(Boolean)
      : [],
    flags: typeof flags === 'number' ? flags : Number(flags) || 0,
  };
};
